import React, { useEffect } from 'react'
import LogoFull from '../components/logo-full'

const TeamSimulationComplete: React.FC = () => {
  // Clear any stored session data
  useEffect(() => {
    localStorage.removeItem('sim_status')
  }, [])

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-6xl mx-auto px-4 py-4">
          <div className="flex items-center justify-center">
            <LogoFull />
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="max-w-md mx-auto text-center bg-white rounded-xl shadow-lg p-8">
          {/* Confetti background effect */}
          <img
            className="absolute top-0 left-0 w-full h-64 object-contain object-top pointer-events-none opacity-70"
            alt=""
            src="/v3/assets/confetti@2x.png"
          />

          <div className="relative z-10">
            {/* Success icon */}
            <div className="w-16 h-16 bg-green-100 rounded-full mx-auto mb-6 flex items-center justify-center">
              <svg
                className="w-8 h-8 text-green-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>

            <h1 className="text-2xl font-bold text-gray-900 mb-4">
              Simulation Completed!
            </h1>

            <p className="text-gray-600 mb-6">
              Great job! Thank you for participating in this team simulation. Your responses have been recorded.
            </p>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
              <p className="text-sm text-blue-800">
                You can safely close this browser window now. If you have any questions about your results, please contact your team administrator.
              </p>
            </div>

            <p className="text-sm text-gray-500">
              Thank you for your participation!
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-4">
        <div className="max-w-6xl mx-auto px-4 text-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} Meseekna. All rights reserved.</p>
        </div>
      </footer>
    </div>
  )
}

export default TeamSimulationComplete
